import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
    // 渠道佣金页面列表
    channelcommissionlist(data) {
        return request.get(`${BASE_URL}/channel-commission/list`,data)
    },

    // 可提现金额检查
    withdrawmoney() {
        return request.get(`${BASE_URL}/channel-commission/withdraw_money`)
    }
}